import React, { useContext, useState } from 'react'
import { Helmet } from 'react-helmet'
import UserContext from '@context/UserContext'
import { Layout } from '@components/Layout'
import LandingPageBanner from '@components/UserAccount/BeachClub/landingpage/LandingPageBanner'
import HeroIntro from '@components/UserAccount/BeachClub/landingpage/HeroIntro'
import RedeemExcitingRewards from '@components/UserAccount/BeachClub/landingpage/RedeemExcitingRewards'
import WaysToEarn from '@components/UserAccount/BeachClub/landingpage/WaysToEarn'
import LoginModal from '@components/modal/LoginModal'
import { navigate } from 'gatsby'

const BlackboughBeachClub = () => {
	const { setOpenLoginModal, isLoggedIn } = useContext(UserContext)
	const [forceShowRegister, setForceShowRegister] = useState(false)

	const handleLoginModal = (showRegisterForm = false) => {
		setForceShowRegister(showRegisterForm)
		if(isLoggedIn) {
			navigate('/user-account/blackbough-beach-club/')
		} else {
			setOpenLoginModal(true)
		}
	}

	return (
		<Layout 
			gaEvent={{
				eventName: 'page_view', 
				params: {
					page_path: '/blackbough-beach-club',
					page_title: 'Blackbough Swim: Designed for the Tropical Soul | Bikinis and Swimwear - Blackbough Swim PH',
					queryName: 'blackbough beach club landing page'
				}
			}} 
			forceShowRegister={forceShowRegister} 
			footerMargin='mb-0'
		>
			<Helmet>
                <title>Blackbough Swim: Designed for the Tropical Soul | Bikinis and Swimwear - Blackbough Swim PH</title>
                <meta name="description" content="Find your new favorite bikini. Shop triple-lined, sustainably-made swimwear in the cutest prints and flattering styles for your every sun-soaked adventure." />
            </Helmet>
			
			<section className='max-container relative'>
				<LandingPageBanner handleLoginModal={handleLoginModal} />
				<HeroIntro handleLoginModal={handleLoginModal} />
				<RedeemExcitingRewards />
				<WaysToEarn />
			</section>
		</Layout>
	)
}

export default BlackboughBeachClub